import { DataBean } from "../../DataBean";


export class CloseProvisions extends DataBean {

    public async closeProvisions(year: any, month: any, idLoggedEmployee: any, closeProvisionsForYear: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_closeProvisions_Number_Number_Number_Boolean", [year, month, idLoggedEmployee, closeProvisionsForYear]);
    }

}